import React, { useEffect, useRef, useCallback } from 'react'
import { Helmet } from 'react-helmet'
import { useCache } from '../../contexts/CacheContext'
import './styles.scss'

import LoadingBars from '../spinner/horizontalLoader'
import ReactJson from '@microlink/react-json-view'

const JsonViewer = ({ url, ext=null }) => {
  const { fetchData, getCacheState } = useCache()
  const { isLoading, data, error } = getCacheState(url)
  const containerRef = useRef(null)
  const scrollPosRef = useRef(0)

  useEffect(() => {
    fetchData(url)
  }, [url, fetchData])

  const handleToggle = useCallback(() => {
    const container = containerRef.current
    if(container) {
      scrollPosRef.current = container.scrollTop
      requestAnimationFrame(() => {
        container.scrollTop = scrollPosRef.current
      })
    }
  }, [])

  if(!data) return null

  let parsedData = data
  if(typeof data === 'string') {
    try {
      parsedData = JSON.parse(data)
    } catch(e) {
      return (
        <div className='sv3-prvw-title'>
          <h2>Invalid JSON</h2>
          <p>Unable to parse JSON data</p>
        </div>
      )
    }
  }

  return (
    <>
      <Helmet>
        <link href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap" rel="stylesheet"/>
      </Helmet>
      <div className='sv3-prvw-title'>
        <h2>
          JSON Preview { isLoading && <>&nbsp;&nbsp;<LoadingBars/></> }
        </h2>
      </div>
      <div className='sv3-prvw-basic-txt' ref={containerRef}>
        <ReactJson
          name={false}
          src={parsedData}
          theme='ashes'
          collapsed={false}
          displayDataTypes={false}
          enableClipboard={false}
          onToggle={handleToggle}
          style={{
            padding: '16px 0',
            backgroundColor: 'transparent',
            fontFamily: "'JetBrains Mono', monospace"
          }}
        />
      </div>
    </>
  )
}

export default JsonViewer